import type { IMosaicTocExpanded, ITocActionRefresh } from "./interface";

/**
 * Replaces the current ToC state with freshly loaded server data.
 *
 * @param state - The current expanded ToC state.
 * @param action - The action containing the refreshed items and metadata.
 * @returns The updated ToC state after the refresh completes.
 */
export const toc_refresh = (
  state: IMosaicTocExpanded,
  action: ITocActionRefresh,
): IMosaicTocExpanded => {
  const newState: IMosaicTocExpanded = { ...state };

  newState.changed = false;
  newState.hierarchyId = action.hierarchyId;
  newState.removedItems = action.removedItems ?? [];
  newState.saving = false;
  newState.saveError = false;
  newState.sendUpdate = false;
  newState.tocItems = [...action.items];
  newState.tocItems.sort(
    (first, second) =>
      (first.tocOrder ??
        // istanbul ignore next -- refreshed ToC items should already carry a persisted order.
        0) -
      (second.tocOrder ??
        // istanbul ignore next -- refreshed ToC items should already carry a persisted order.
        0),
  );

  return newState;
};
